export default {
  name: "synthesisText",
  props: {
    text: {
      type: String
    }
  }
};
